import { emailFlagsFromApi, emailFlagsToApi } from '../Common/emailFlags';

const createGroupModel = (group = {}) => {
  return {
    id: group.id || null,
    name: group.name || '',
    slug: group.slug || '',
    hideAnalysisPractice: group.hide_analysis_practice || false,
    hideAnalysisSimulation: group.hide_analysis_simulation || false,
    hideReports: group.hide_reports || false,
    roundedCefrCertificate: group.rounded_cefr_certificate || false,
    roundedOverall: group.rounded_overall || false,
    roundedCategories: group.rounded_categories || false,
    hideCustomTests: group.hide_custom_tests || false,
    hasSimulations: group.has_simulations || false,
    showCEFRLanguage: group.show_cefr_language || false,
    contentType: group.content_type?.id || '',
    hideQrCodeCertificate: group.hide_qr_code_certificate || false,
    hideCategoriesScoreCertificate:
      group.hide_categories_score_certificate || false,
    showEnrollmentNumberCertificate:
      group.show_enrollment_number_certificate || false,
    enrollmentNumberCertificateLabel:
      group.enrollment_number_certificate_label ?? '',
    scoreControl: group.score_control || false,
    scoreAvailable: group.score_available ?? true,
    certificateAvailable: group.certificate_available ?? true,
    emailSettings: group.email_settings ?? true,
    ...emailFlagsFromApi(group),
    language: group.language || '',
    turnA0ToDash: group.turn_a0_to_hifen || false,
    twoFactorMode: group.two_factor_mode || 'disabled',
    twoFactorTotpEnabled: group.two_factor_totp_enabled || false,
    twoFactorEmailEnabled: group.two_factor_email_enabled || false,
  };
};

const createGroupRequestModel = (group = {}) => {
  return {
    id: group.id,
    name: group.name,
    slug: group.slug,
    hide_analysis_practice: group.hideAnalysisPractice,
    hide_analysis_simulation: group.hideAnalysisSimulation,
    hide_reports: group.hideReports,
    hide_custom_tests: group.hideCustomTests,
    rounded_cefr_certificate: group.roundedCefrCertificate,
    rounded_overall: group.roundedOverall,
    rounded_categories: group.roundedCategories,
    has_simulations: group.hasSimulations,
    show_cefr_language: group.showCEFRLanguage,
    content_type_id: group.contentType,
    hide_qr_code_certificate: group.hideQrCodeCertificate,
    hide_categories_score_certificate: group.hideCategoriesScoreCertificate,
    show_enrollment_number_certificate: group.showEnrollmentNumberCertificate,
    enrollment_number_certificate_label: group.enrollmentNumberCertificateLabel,
    score_control: group.scoreControl,
    score_available: group.scoreAvailable,
    certificate_available: group.certificateAvailable,
    email_settings: group.emailSettings,
    ...emailFlagsToApi(group),
    language: group.language,
    turn_a0_to_hifen: group.turnA0ToDash,
    two_factor_mode: group.twoFactorMode,
    two_factor_totp_enabled: group.twoFactorTotpEnabled,
    two_factor_email_enabled: group.twoFactorEmailEnabled,
  };
};

export { createGroupModel, createGroupRequestModel };
